export const appProxySubpathPrefixList = ["apps", "a", "community", "tools"]
